var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagePlaceholderSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 345,
    viewBox: "0 0 293 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 345,
    rx: 20,
    fill: "#F4EFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(87.5,125.25)",
    d: "M99.6875 82.5H10.3125C4.61699 82.5 0 77.883 0 72.1875V10.3125C0 4.61699 4.61699 0 10.3125 0H99.6875C105.383 0 110 4.61699 110 10.3125V72.1875C110 77.883 105.383 82.5 99.6875 82.5ZM24.0625 12.0312C17.4178 12.0312 12.0312 17.4178 12.0312 24.0625C12.0312 30.7072 17.4178 36.0938 24.0625 36.0938C30.7072 36.0938 36.0938 30.7072 36.0938 24.0625C36.0938 17.4178 30.7072 12.0312 24.0625 12.0312ZM13.75 68.75H96.25V44.6875L77.4479 25.8854C76.4412 24.8787 74.8088 24.8787 73.8018 25.8854L44.6875 55L32.7604 43.0729C31.7537 42.0662 30.1213 42.0662 29.1143 43.0729L13.75 58.4375V68.75Z",
    fill: "url(#paint0_linear_29_77)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_77",
    x1: 55,
    y1: 0,
    x2: 55,
    y2: 82.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholderSmall);
export default __webpack_public_path__ + "static/media/imagePlaceholderSmall.7161d68f944e05b3f42d734c9881f838.svg";
export { ForwardRef as ReactComponent };